import script from "./GreenMailIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./GreenMailIcon.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__